let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("d0X7J")]).then(() => parcelRequire('ebIkR'));